import React from 'react';
import { List, Skeleton } from 'antd';

export const SkeletonList = props => {
	let { itemsCount, loading, marginTop, title = true, rows = 2 } = props;
	let fakeData: any[] = [];
	for (let i = 0; i < itemsCount; i++) {
		fakeData[i] = i;
	}
	return (
		<List
			dataSource={fakeData}
			itemLayout="vertical"
			size="default"
			style={{ marginTop: marginTop || 'auto' }}
			renderItem={i => (
				<List.Item key={i} style={{ padding: '1.5rem 1rem', paddingLeft: '2.2rem' }}>
					<Skeleton loading avatar active title={title} paragraph={{ rows: rows }}></Skeleton>
				</List.Item>
			)}
		/>
	);
};
